export default {
  placeholder: 'Wybierz plan załadunku',
};
